import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CalendarItemSelector = ({ items, value, onChange }) => {
  const { t } = useTranslation();
  const handleChange = (event) => {
    const selectedValue = event.target.value;
    const selectedItem = items.find(i => i.yksikkoId === selectedValue);
    if (selectedItem) {
      onChange(selectedItem.yksikkoId, selectedItem.nimi);
    }
  };

  return (
    <FormControl fullWidth sx={{ mt: 1 }}>
      <InputLabel>{t('calendar.product')}</InputLabel>
      <Select value={value || ''} label={t('calendar.product')} onChange={handleChange}>
        {
          items.map(i => (
            <MenuItem key={i.yksikkoId} value={i.yksikkoId}>
              {i.nimi}
            </MenuItem>
          ))
        }
      </Select>
    </FormControl>
  );
};

export default CalendarItemSelector;
